import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BrandOverlayEntity, BrandOverlayEntityRaw } from "@common/domain";
import { ApiService } from "@youm-front/api/data-access";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  RoomBrandOverlayCreateRequestDTO,
  RoomBrandOverlayCreateResponseDTO,
  RoomBrandOverlayDeleteRequestDTO,
  RoomBrandOverlayDeleteResponseDTO,
  RoomBrandOverlayUnUseRequestDTO,
  RoomBrandOverlayUseRequestDTO
} from "../dto";

@Injectable()
export class RoomBrandOverlayService {
  constructor(private readonly apiService: ApiService) {}

  roomBrandOverlayCreate(
    roomBrandOverlayCreateRequestDTO: RoomBrandOverlayCreateRequestDTO
  ): Observable<RoomBrandOverlayCreateResponseDTO> {
    const formData = new FormData();

    formData.set("overlay", roomBrandOverlayCreateRequestDTO.data.data);
    formData.set("width", roomBrandOverlayCreateRequestDTO.data.width + "");
    formData.set("height", roomBrandOverlayCreateRequestDTO.data.height + "");

    return this.apiService
      .post<{ brandOverlay: BrandOverlayEntityRaw }>(
        `rooms/${roomBrandOverlayCreateRequestDTO.data.roomId}/brands/${roomBrandOverlayCreateRequestDTO.data.brandId}/overlays`,
        formData,
        "v1",
        new HttpHeaders().set("Content-Type", "multipart/form-data")
      )
      .pipe(
        map(
          (_) =>
            new RoomBrandOverlayCreateResponseDTO({
              brandOverlay: new BrandOverlayEntity(_.brandOverlay)
            })
        )
      );
  }

  roomBrandOverlayDelete(
    roomBrandOverlayDeleteRequestDTO: RoomBrandOverlayDeleteRequestDTO
  ): Observable<RoomBrandOverlayDeleteResponseDTO> {
    return this.apiService
      .delete(
        `rooms/${roomBrandOverlayDeleteRequestDTO.data.roomId}/brands/${roomBrandOverlayDeleteRequestDTO.data.brandOverlay.value.brandId}/overlays/${roomBrandOverlayDeleteRequestDTO.data.brandOverlay.value.id}`
      )
      .pipe(
        map(
          () =>
            new RoomBrandOverlayDeleteResponseDTO({
              roomId: roomBrandOverlayDeleteRequestDTO.data.roomId,
              brandOverlay: roomBrandOverlayDeleteRequestDTO.data.brandOverlay
            })
        )
      );
  }

  roomBrandOverlayUnUse(
    roomBrandOverlayUnUseRequestDTO: RoomBrandOverlayUnUseRequestDTO
  ): Observable<void> {
    return this.apiService.delete<void>(
      `rooms/${roomBrandOverlayUnUseRequestDTO.data.roomId}/brands/${roomBrandOverlayUnUseRequestDTO.data.brandOverlay.value.brandId}/overlays/${roomBrandOverlayUnUseRequestDTO.data.brandOverlay.value.id}/use`
    );
  }

  roomBrandOverlayUse(
    roomBrandOverlayUseRequestDTO: RoomBrandOverlayUseRequestDTO
  ): Observable<void> {
    return this.apiService.post<void>(
      `rooms/${roomBrandOverlayUseRequestDTO.data.roomId}/brands/${roomBrandOverlayUseRequestDTO.data.brandOverlay.value.brandId}/overlays/${roomBrandOverlayUseRequestDTO.data.brandOverlay.value.id}/use`,
      {}
    );
  }
}
